<template>
	<div>
		<Subpage/>		  
      	<div class="page-content container">
        	<main>         
				<h1 class="page-title">Mapa strony</h1>         
				<div class="breadcrumbs-area">
					<nav aria-label="breadcrumb">
						<ol class="breadcrumbs" itemscope itemtype="http://schema.org/BreadcrumbList">
							<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
								<router-link itemprop="item" to="/"><span itemprop="name">Strona gł&oacute;wna</span></router-link><span class="separator">/</span>
							</li>
							<li class="active">Mapa strony</li></ol>
					</nav>
				</div>				   
				    <ul class="tree">
				    	<li class="nav-home">
				    		<router-link  to="/" target="_self" class="nav-home">Strona gł&oacute;wna</router-link >
				    	</li>
				    	<li class="">
				    		<router-link  to="/kim-jestesmy" target="_self" class="">Kim jesteśmy?</router-link >
				    	</li>
				    	<li class="">
				    		<router-link  to="/co-mozemy-dla-ciebie-zrobic" target="_self" class="">Co możemy dla Ciebie zrobić?</router-link >
				    	</li>
				    	<li class="">
				    		<router-link  to="/skontaktuj-sie-z-nami" target="_self" class="">Skontaktuj się z nami!</router-link >
				    	</li>
				    	<li class="">
				    		<router-link  to="/czy-wiecie-ze" target="_self" class="">Czy wiecie, że...</router-link >
				    		<ul>
				    			<li class=""><router-link  to="/czy-wiecie-ze/gliwicka-radiostacja" target="_self" class="">Gliwicka Radiostacja</router-link >
				    			</li>
				    		</ul>
				    	</li>
				    	<li class="">
				    		<router-link  to="/polityka-prywatnosci" target="_self" class="">Polityka prywatności</router-link >
				    	</li>
				    	<li class="nav-selected nav-path-selected">
				    		<router-link  to="/mapa-strony" target="_self" class="nav-selected nav-path-selected">Mapa strony</router-link >
				    	</li>
				    </ul>
        	</main>
    	</div>
	</div>
</template>
<script>
import Subpage from '@/components/Subpage.vue'
export default {
  name: 'SiteMap',
  components: {
    Subpage
  }
}
</script>